<template>
  <router-view v-slot="{ Component }">
    <component
      :is="Component"
      :key="$route.name"
      v-if="!$route.meta.keepAlive"
    ></component>
    <keep-alive>
      <component
        :is="Component"
        :key="$route.name"
        v-if="$route.meta.keepAlive"
      ></component>
    </keep-alive>
  </router-view>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
#app {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  font-size: 28px;
}
.card-wrapper {
    margin: 32px;
    border-radius: 20px;
    background: #fff;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    padding: 24px;  
    font-size: 32px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    .card-title{
      font-weight: 500;
    }
    .more-btn{
      font-size: 24px;
      color: rgba(51, 51, 51, 0.5);
      a{
        font-size: 24px;
        color: rgba(51, 51, 51, 0.5);
      }
    }
  }
  .card-content {
    padding: 24px;
    .rate-label {
      line-height: 64px;
      color: rgba(30, 34, 38, 1);
    }
    .rate-value {
      color: rgba(0, 0, 0, 0.5);
    }
    .divider {
      margin: 0 32px;
      height: 16px;
      width: 1px;
      background: rgba(204, 204, 204, 1);
    }
    .skill-service {
      margin-top: 24px;
    }
    .tag{
      margin-bottom: 8px;
      margin-right: 8px;
      padding:6px 16px;
      font-size: 22px;
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.green{
        color: rgba(61, 185, 99, 1);
        background: rgba(67, 207, 124, 0.1);
      }
      &.blue{
        color: rgba(0, 174, 255, 1);
        background: rgba(0, 174, 255, 0.1);
      }
    }
  }
</style>
